// Widget Scripts

import customHeaderButtons from './js/widgets/headerButtons/customHeaderButtons.js';
import customTicketButton from './js/widgets/headerButtons/customTicketButton.js';
import mainSlideshow from './js/widgets/mainFeature/mainSlideshow.js';
import autoFeed from './js/widgets/mainFeature/autoFeed.js';
import animatedMetrics from './js/widgets/tier2Section/animatedMetrics.js';
import eventTitleLink from './js/widgets/tier2Section/eventTitleLink.js';
import customCards from './js/widgets/seoAndCards/customCards.js';
import seoBlock from './js/widgets/seoAndCards/seoBlock.js';
import getDirectionsWidget from './js/widgets/getDirectionsWidget.js';
import customSignup from './js/widgets/customSignup.js';
import galleryCards from './js/widgets/galleryCards.js';

// -----------------------
// Custom Theme Scripts
import './js/localjs.js';

// -----------------------

// Initialize Homepage Widgets
$(document).ready(function () {
  customHeaderButtons();
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    autoFeed();
    customCards();
    seoBlock();
    getDirectionsWidget();
    customSignup();

    if ($('body').hasClass('eventsMode')) {
      eventTitleLink();
    } else {
      animatedMetrics();
    }
  }
  galleryCards();
});
